export const Project = {
    isProjectListLoading: false,
    isArchiveProjectLoading: false,
    isProjectLoading: false,
    opinionExecuting: [],
    commentExecuting: [],
    voteExecuting: [],
    project: null,
    projects: [],
    archiveProjects: [],
    totalProjects: 0,
    totalArchiveProjects: 0
}